module.exports = __webpack_public_path__ + "img/precupetii-marker_ro.e3255220.png";